// @ts-nocheck
import React from "react";
import { t } from "i18next";
import DocUploader, { SingleDocUploader } from "../../DocUploader/DocUploader";
import useTemplate from "hooks/useTemplate";

export default function DocContentStep(props) {
	let doc = props.object;
	const { template } = useTemplate();

	return (
		<div className="inner-step-cont">
			<div className={`DocUploader full ${props.className || ""}`}>
				<div className="d-flex justify-content-between align-items-center mb-4">
					<h2>{t("Files.IMPORT_FROM_PC")}</h2>

					<SingleDocUploader
						primaryColor={template?.primaryColor()}
						companyId={doc.companyId()}

						doc={doc}
						showRemove={false}
					/>

				</div>
			</div>
		</div>
	);
}

export function checkDocument(doc) {
	let errors = [];

	if (!doc.name())
		errors.push(t("Files.SET_NAME"));
	if (!doc.documentId() && !doc.documentFile())
		errors.push(t("Files.SELECT_FILE"));

	return (errors?.length ? errors : true);
}
